export const FETCH_LINKED_USERS = 'FETCH_LINKED_USERS';
export const STORE_LINKED_USERS = 'STORE_LINKED_USERS';
export const EDIT_USER = 'EDIT_USER';
export const DELETE_USER = 'DELETE_USER'

export const GET_ROLES = 'GET_ROLES'
export const STORE_ROLES = 'STORE_ROLES'

export const REGISTER_RFID = 'REGISTER_RFID';
export const STORE_RFID = 'STORE_RFID'
export const DELETE_RFID = 'DELETE_RFID'
export const PROCESS_RFID = 'PROCESS_RFID'
export const UPLOAD_BONUS_PHOTO = 'UPLOAD_BONUS_PHOTO'

export const FETCH_LOCATION_DETAIL = 'FETCH_LOCATION_DETAIL';
export const STORE_LOCATION_DETAIL = 'STORE_LOCATION_DETAIL';